import { PageContentType } from '@/contentful/contentful.types';
import { PUBLIC_BATTERY_ECOMM_ROUTES } from '@/utils/publicBatteryEcomm/pageUrls';

const V4_ROUTE_SETS: readonly (readonly string[])[] = [
  Object.values(PUBLIC_BATTERY_ECOMM_ROUTES),
];

const V4_PAGE_CONTENT_TYPES: readonly string[] = [
  PageContentType.MULTI_PRODUCT,
];

// Routes that use the V4 theme
export function isV4Route(pathname: string): boolean {
  return V4_ROUTE_SETS.some((routes) => routes.includes(pathname));
}

// CMS pages share the catch-all route, so the page content type picks the theme
export function isV4PageContentType(contentType: string | undefined): boolean {
  return (
    contentType !== undefined && V4_PAGE_CONTENT_TYPES.includes(contentType)
  );
}
